var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-header", attrs: { id: "dashBoardHeader" } },
    [
      _c("div", { staticClass: "dashboard-header__inner" }, [
        _c("div", { staticClass: "dashboard-header__user" }, [
          _c("span", { staticClass: "user-name" }, [_vm._v(_vm._s(_vm.abo))]),
          _vm._v(" "),
          _c("span", { staticClass: "user-num" }, [
            _vm._v("(" + _vm._s(_vm.name) + ")")
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "dashboard-header__title" }, [
      _vm._v("2023년 3월 "),
      _c("br", { staticClass: "mo" }),
      _vm._v("신규 ABO 프로모션 후원 현황")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dashboard-header__link",
        attrs: { href: "https://www.amway.co.kr/main" }
      },
      [
        _c("span", { staticClass: "logo" }, [
          _c("span", { staticClass: "hidden" }, [_vm._v("Amway")])
        ]),
        _vm._v("\n      홈으로 >\n    ")
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d242dbfa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d242dbfa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard2/component/header.vue
// module id = null
// module chunks = 